// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useMemo } from 'react'
import { array, func, object, oneOfType, string } from 'prop-types'
import DataItem from './DataItem'
import { DataRowWrapper } from './styles'

// this is a <tr />

const DataRow = React.memo(props => {
  const {
    columns,
    handleRowClick,
    rowClass,
    rowData,
  } = props

  const rowClasses = useMemo(() => {
    let classes = ''
    classes += handleRowClick ? 'cursor-pointer' : ''

    // if there's any special row classes to apply, add em here
    if (typeof rowClass === 'string') {
      classes += ` ${rowClass}`
    } else if (typeof rowClass === 'function') {
      classes += ` ${rowClass(rowData)}`
    }

    return classes
  }, [columns, rowData])

  return (
    <DataRowWrapper
      className={rowClasses}
      onClick={() => handleRowClick && handleRowClick(rowData)}>
      {
        columns.map(d => (
          <DataItem
            key={d.field}
            columnData={d}
            rowData={rowData} />
        ))
      }
    </DataRowWrapper>
  )
})

DataRow.propTypes = {
  columns: array.isRequired,
  handleRowClick: func,
  rowClass: oneOfType([
    func,
    string,
  ]),
  rowData: object.isRequired,
}

export default DataRow
